import { LoopFilterTags, Protocol, VaultMetadataTag } from "@bridgesplit/abf-sdk";

import { FilterType, FilterConfig, PluralLabelText } from "../types";

export const EXPLORE_LOOPS_FILTER_DEFAULT = {
    DepositAssets: {
        enabled: false,
        condition: new Set<string>()
    },
    Tag: {
        enabled: false,
        condition: new Set<LoopFilterTags>()
    },
    IncludeNegativeApys: {
        enabled: true,
        condition: false
    },
    Protocols: {
        enabled: false,
        condition: new Set<Protocol>()
    },
    BorrowAssets: {
        enabled: false,
        condition: new Set<string>()
    },
    NewOnly: {
        enabled: false,
        condition: false
    }
};

/** Vault metadata tags exposed as user-facing category filters (excludes system tags like urlAccessOnly). */
export const VAULT_CATEGORY_FILTER_TAGS = [
    VaultMetadataTag.Featured,
    VaultMetadataTag.Popular,
    VaultMetadataTag.Stablecoins,
    VaultMetadataTag.SOL,
    VaultMetadataTag.LP,
    VaultMetadataTag.BTC,
    VaultMetadataTag.Collateral
] as const satisfies readonly VaultMetadataTag[];

export const EXPLORE_VAULTS_FILTER_DEFAULT = {
    DepositAssets: {
        enabled: false,
        condition: new Set<string>()
    },
    Tag: {
        enabled: false,
        condition: new Set<VaultMetadataTag>()
    }
};

export const EXPLORE_LOOPS_FILTER_CONFIG = {
    DepositAssets: FilterType.MultiSelect,
    BorrowAssets: FilterType.MultiSelect,
    Protocols: FilterType.MultiSelect,
    Tag: FilterType.MultiSelect,
    IncludeNegativeApys: FilterType.InclusiveBoolean,
    NewOnly: FilterType.Boolean
} satisfies FilterConfig;

export const EXPLORE_VAULTS_FILTER_CONFIG = {
    DepositAssets: FilterType.MultiSelect,
    Tag: FilterType.MultiSelect
} satisfies FilterConfig;

export const VAULT_CATEGORIES_BUTTON_LABEL: PluralLabelText = {
    desktop: {
        all: "All categories",
        single: "category",
        multi: "categories"
    },
    mobile: {
        all: "All"
    }
};

export const DEPOSIT_ASSETS_BUTTON_LABEL: PluralLabelText = {
    desktop: {
        all: "All deposit assets",
        single: "deposit asset",
        multi: "deposit assets"
    },
    mobile: {
        all: "All"
    }
};

export const STRATEGIES_BUTTON_LABEL: PluralLabelText = {
    desktop: {
        all: "All strategies",
        single: "strategy",
        multi: "strategies"
    },
    mobile: {
        all: "All"
    }
};

export const ADDITIONAL_FILTERS_BUTTON_LABEL: PluralLabelText = {
    desktop: {
        all: "Filters",
        single: "filter",
        multi: "filters"
    },
    mobile: {
        all: "Additional filters"
    }
};

export const INCLUDE_NEGATIVE_APY_BUTTON_LABEL: PluralLabelText = {
    desktop: {
        all: "APYs",
        single: "APY",
        multi: "APYs"
    },
    mobile: {
        all: "APY filters"
    }
};
